import React from "react";
import { useCharacter } from "../../../hooks/use-character";
import Field from "../../ui/Field";

interface Props {
  className?: string;
}

const Beard: React.FC<Props> = ({ className }) => {
  const {
    mode,
    handleBeardChange,
    character: {
      beard: { facial_hair },
    },
  } = useCharacter();

  return (
    <div className={`space-y-8 ${className}`}>
      {/** Facial Hair */}
      <Field
        type="stepper"
        label="Barbă"
        description="Reglează forma și grosimea bărbii"
        initialValue={facial_hair}
        onChange={(value) => handleBeardChange({ facial_hair: Number(value) })}
        min={0}
        max={29}
      />
    </div>
  );
};

export default Beard;
